import asyncActionTypes from '../actions/types.js';

const initialState = {
  storeFronts: [],
  loadingStoreFront: false,
};

const storeFront = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.STORE_FRONTS.START:
      return {
        ...state,
        loadingStoreFront: true,
      };
    case asyncActionTypes.STORE_FRONTS.SUCCESS:
      return {
        ...state,
        loadingStoreFront: false,
        storeFronts: Array.isArray(action.payload.response) ? action.payload.response : [],
      };
    case asyncActionTypes.STORE_FRONTS.FAIL:
      return {
        ...state,
        loadingStoreFront: false,
        storeFronts: [],
      };
    default:
      return state;
  }
};

export default storeFront;
